import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { UserService } from "../service/auth/user.service";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private userService: UserService,
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const clonedReq = req.clone({
            withCredentials: true
        });
        return next.handle(clonedReq).pipe(
            tap(
                succ => { },
                err => {
                    if (err.status == 401) {
                        localStorage.setItem("logged", "");
                        this.userService.logOut().subscribe(
                            res => {
                                window.location.href = "/techbyte/admin/login";
                            }
                        );
                    }
                    else if (err.status == 403)
                        this.router.navigateByUrl('/techbyte/admin/error');
                }
            )
        )
    }
}